import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Button  } from "antd";
import { AppContext } from '../../util/context';
import "../../pages/Home/Home.css";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export const Insights = ({data, tab, modalDetails, setModalDetails, myData}) => {
    const {
        StyledDiv
    } = useContext(AppContext)

    const [insightDetails, setInsightDetails] = useState({
        total: 0,
        open: 0,
        closed: 0,
        voided: 0,
        assigned: 0,
        completed: 0,
        overdue: 0,
        withinTargetDate: 0
    })

    useEffect(() => {
        let mounted = true;

        const getInsights = () => {
            let total = 0;
            let open = 0;
            let closed = 0;
            let voided = 0;
            let assigned = 0;
            let completed = 0;
            let overdue = 0;
            let withinTargetDate = 0;
            if(data.length > 0){
                total = data.length;
                open = data.filter(card => card.status === "open").length;
                if(tab === 'mycards' || tab === 'allcards' || tab === 'myteamscards' || tab === 'assignedactionstoteam'){
                    assigned = data.filter(card => card.status === "assigned").length;
                }
                closed = data.filter(card => card.status === "closed").length;
                voided = data.filter(card => card.status === "void").length;
                if(tab === 'myactions' || tab === 'allactions' || tab === 'assignedactions'){
                    if (tab === 'allactions' || tab === 'assignedactions') {
                        const today = dayjs();
            
                        const newoverdue = data.filter(card => {
                            const dueDate = dayjs(card.dueDate, 'YYYY-MM-DD');
                            return (card.status === "assigned" || card.status === "reassigned") && dueDate.isBefore(today, 'day');
                        }).length;
            
                        const newwithinTargetDate = data.filter(card => {
                            const dueDate = dayjs(card.dueDate, 'YYYY-MM-DD');
                            return (card.status === "assigned" || card.status === "reassigned") && dueDate.isSameOrAfter(today, 'day');
                        }).length;
            
                        overdue = newoverdue;
                        withinTargetDate = newwithinTargetDate;
                    }
                    assigned = data.filter(card => card.status === "assigned" || card.status === "reassigned").length;
                    completed = data.filter(card => card.status === "completed").length;
                }
            }
            setInsightDetails({
                total,
                open,
                closed,
                voided,
                assigned,
                completed,
                overdue,
                withinTargetDate
            })
        }

        if (mounted) {
            getInsights()
        }

        return () => {
            mounted = false;
        }
    }, [data, tab])
    
    return (
        <>
            <Row
                style={{
                    height: modalDetails.show && modalDetails.insights ? "90%" : "98%",
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingBottom: "20px"
                }}
            >
                <Col
                    span={24}
                >
                    <Row
                        className="insightContainer"
                    >
                        <Col
                            span={24}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "black"
                                    }}
                                >
                                    TOTAL[YTD] {insightDetails.total}
                                </StyledDiv>
                            </div>
                            
                        </Col>
                    </Row>

                    {tab !== 'assignedactionstoteam' && <Row
                        className="insightContainer"
                        style={{
                            backgroundColor: "#eaeaea",
                            marginTop: "25px"
                        }}
                    >
                        <Col
                            span={24}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#FF0000"
                                    }}
                                >
                                    OPEN {insightDetails.open}
                                </StyledDiv>
                            </div>
                            
                        </Col>
                    </Row>}

                    {(tab === 'mycards' || tab === 'allcards' || tab === 'myteamscards' || tab === 'assignedactionstoteam') && <>
                        <Row
                            className="insightContainer"
                            style={{
                                backgroundColor: "#eaeaea",
                                marginTop: "25px"
                            }}
                        >
                                <Col
                                    span={24}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <StyledDiv
                                            style={{
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                color: "#C00000"
                                            }}
                                        >
                                            ASSIGNED {insightDetails.assigned}
                                        </StyledDiv>
                                    </div>
                                    
                                </Col>
                        </Row>
                    </>}

                    {(tab === 'myactions' || tab === 'allactions' || tab === 'assignedactions') && <>
                        <Row
                            className="insightContainer"
                            style={{
                                backgroundColor: "#eaeaea",
                                marginTop: "25px"
                            }}
                        >
                            {(tab === 'allactions' || tab === 'assignedactions') && <>
                                <Col
                                    span={24}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <StyledDiv
                                            style={{
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                color: "#C00000"
                                            }}
                                        >
                                            ASSIGNED {insightDetails.assigned}
                                        </StyledDiv>
                                    </div>
                                    
                                </Col>

                                <Col
                                    span={24}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <StyledDiv
                                            style={{
                                                fontSize: "10px",
                                                fontWeight: "600",
                                                color: "#C00000"
                                            }}
                                        >
                                        OVERDUE {insightDetails.overdue}
                                        </StyledDiv>
                                    </div>
                                    
                                </Col>

                                <Col
                                    span={24}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <StyledDiv
                                            style={{
                                                fontSize: "10px",
                                                fontWeight: "600",
                                                color: "#C00000"
                                            }}
                                        >
                                            WITHIN TARGET DATE {insightDetails.withinTargetDate}
                                        </StyledDiv>
                                    </div>
                                    
                                </Col>
                            
                            </>}

                            {!(tab === 'allactions' || tab === 'assignedactions') && <Col
                                span={24}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <StyledDiv
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            color: "#C00000"
                                        }}
                                    >
                                        ASSIGNED {insightDetails.assigned}
                                    </StyledDiv>
                                </div>
                                
                            </Col>}
                        </Row>

                        <Row
                            className="insightContainer"
                            style={{
                                backgroundColor: "#eaeaea",
                                marginTop: "25px"
                            }}
                        >
                            <Col
                                span={24}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <StyledDiv
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            color: "#92D050"
                                        }}
                                    >
                                        COMPLETED {insightDetails.completed}
                                    </StyledDiv>
                                </div>
                                
                            </Col>
                        </Row>
                    </>}

                    
                    {myData && <Row
                        className="insightContainer"
                        style={{
                            backgroundColor: "#eaeaea",
                            marginTop: "25px"
                        }}
                    >
                        <Col
                            span={24}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#2ca12a"
                                    }}
                                >
                                    CLOSED {insightDetails.closed}
                                </StyledDiv>
                            </div>
                            
                        </Col>
                    </Row>}

                    {myData && <Row
                        className="insightContainer"
                        style={{
                            backgroundColor: "#eaeaea",
                            marginTop: "25px"
                        }}
                    >
                        <Col
                            span={24}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#757575"
                                    }}
                                >
                                    VOID {insightDetails.voided}
                                </StyledDiv>
                            </div>
                            
                        </Col>
                    </Row>}
                    
                </Col>
            </Row>

            {modalDetails.show && modalDetails.insights && <Row
                style={{
                    height: "10%",
                }}
            >
                <Col
                    span={24}
                >
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%"
                        }}
                    >
                        <Button
                            onClick={() => setModalDetails({show: false, insights: false})}
                        >Close</Button>
                    </Row>
                </Col>
            </Row>}
            

            
        </>
    )
}
